import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';
import { paintPreview } from './rsa-frame-renderer-v4.js';
import { artworkSources } from './rsa-artwork-sources-v2.js';
const frames = {
 'Framed- Black': {url:"https://cdn.shopify.com/s/files/1/0950/4787/6910/files/5Frame_Mockup_PSD005_Large_52e3f8c3-6cc7-4057-93cd-18c1e3547e15.jpg?v=1765188161", geometry:{x:[733,775,2227,2268],y:[376,422,2637,2683]}, profile:0.5},
 'Framed- Wood': {url:'https://cdn.shopify.com/s/files/1/0950/4787/6910/files/rsa-real-wood-frame-reference.jpg?v=1791740733', geometry:{strip:{x:250,y:503,width:700,height:23}},profile:0.5},
 'Palazzo': {url:"https://cdn.shopify.com/s/files/1/0950/4787/6910/files/rsa-palazzo-frame.png?v=1791737700", geometry:{x:[20,185,840,1005],y:[150,335,1210,1390]}, profile:2},
 'Atelier': {url:"https://cdn.shopify.com/s/files/1/0950/4787/6910/files/rsa-atelier-muted-v2.png?v=1791749471", geometry:{x:[23,140,887,1001],y:[149,269,1297,1408]}, profile:1.3},
 'Muse': {url:"https://cdn.shopify.com/s/files/1/0950/4787/6910/files/rsa-muse-frame.png?v=1791737728", geometry:{x:[29,167,857,995],y:[140,273,1261,1396]}, profile:1.3}
};
const images = new Map();
function loadImage(url) {
 if (!images.has(url)) images.set(url,new Promise((resolve,reject)=>{const image=new Image();image.onload=()=>resolve(image);image.onerror=()=>{images.delete(url);reject(new Error('Image unavailable'));};image.src=url;}));
 return images.get(url);
}
class RsaFramePreview extends Component {
 connectedCallback() {
  super.connectedCallback();
  const source = artworkSources[this.dataset.productId];
  if (!source) return;
  this.dataset.artUrl = source.url;
  this.dataset.artCrop = JSON.stringify(source.crop);
  this.landscape = source.crop.width > source.crop.height;
  this.controller = new AbortController();
  const section=this.closest('.shopify-section');
  section?.addEventListener('change',event=>{
   const picker=event.target.closest('variant-picker');
   if (!picker || picker.dataset.productId !== this.dataset.productId) return;
   const values=[...picker.querySelectorAll('fieldset input:checked,select')].map(input=>input.value);
   if(values.length===2)this.render(values[0],values[1]);
  },{signal:this.controller.signal});
  section?.addEventListener(ThemeEvents.variantUpdate,event=>{
   if(String(event.detail.data.productId)!==this.dataset.productId)return;
   const variant=event.detail.resource;
   if(variant)this.render(variant.option1,variant.option2);
  },{signal:this.controller.signal});
  this.render(this.dataset.size,this.dataset.frame);
 }
 disconnectedCallback(){super.disconnectedCallback();this.controller?.abort();this.version=(this.version||0)+1;}
 updatePrice(sizeLabel,frameName){
  const price=this.querySelector('[data-preview-price]');
  if(!price)return;
  const match=[...this.querySelectorAll('[data-preview-prices] [data-price]')].find(item=>item.dataset.size===sizeLabel&&item.dataset.frame===frameName);
  price.textContent=match?.dataset.price||'';
  price.hidden=!match;
 }
 async render(sizeLabel,frameName){
  const version=this.version=(this.version||0)+1;
  this.updatePrice(sizeLabel,frameName);
  const size=(sizeLabel.match(/[\d.]+/g)||[]).map(Number);
  if(size.length!==2)return;
  const source=artworkSources[this.dataset.productId];
  if(!source)return;
  const crop=source.crop;
  const landscape=crop.width>crop.height;
  if((landscape && size[0]<size[1]) || (!landscape && size[0]>size[1]))size.reverse();
  const frameKey=frameName.startsWith('Frame- ')?({'Black':'Framed- Black','Wood':'Framed- Wood'}[frameName.slice(7)]||frameName.slice(7)):frameName;
  const config=frames[frameKey];
  const picker=this.closest('.shopify-section')?.querySelector('variant-picker');
  picker?.querySelectorAll('[data-rsa-frame-choice]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.rsaFrameChoice===frameName)));
  if(!config&&frameName!=='Flat Print')return;
  try{
   const [art,frame]=await Promise.all([loadImage(source.url),config?loadImage(config.url):Promise.resolve(null)]);
   if(version!==this.version||!this.isConnected)return;
   paintPreview(this.querySelector('canvas'),art,crop,frame,config?.geometry,size,config?.profile||0);
   this.querySelector('canvas').setAttribute('aria-label',this.dataset.title+' — '+frameName+' — '+sizeLabel);
   this.querySelector('canvas').hidden=false;
   this.querySelector('.rsa-preview-fallback').hidden=true;
   this.querySelector('[data-preview-status]').textContent=frameName+' · '+sizeLabel;
   this.dataset.renderedFrame=frameName;
   this.dataset.renderedSize=sizeLabel;
   this.dataset.ready='true';
  }catch{
   this.querySelector('canvas').hidden=true;
   this.querySelector('.rsa-preview-fallback').hidden=false;
   this.querySelector('[data-preview-status]').textContent=this.dataset.error;
   this.dataset.ready='false';
  }
 }
}
if(!customElements.get('rsa-frame-preview'))customElements.define('rsa-frame-preview',RsaFramePreview);


document.addEventListener('click',event=>{
 const button=event.target.closest('[data-rsa-frame-choice]');
 if(!button)return;
 const picker=button.closest('variant-picker');
 if(!picker)return;
 const input=[...picker.querySelectorAll('input[type="radio"]')].find(input=>input.value===button.dataset.rsaFrameChoice);
 if(input && !input.disabled)input.click();
});
